import React from 'react';
import {
  DownloadOutlined,
  PrinterOutlined,
  ArrowLeftOutlined,
  SaveOutlined,
  BarsOutlined,
  EditOutlined,
  SearchOutlined,
  CloseOutlined,
  DeleteOutlined,
  PlusOutlined,
  ClearOutlined,
} from '@ant-design/icons';
import {
  ALERTA,
  MSG_NENHUM_ARQUIVO_ENCONTRADO,
  MSG_FORMATO_NAO_PERMITIDO_PDF,
  MSG_TAMANHO_ARQUIVO_NAO_SUPORTADO,
} from 'utils/consts';
import { fetchNotificationApp } from 'store/fetchActions/fetchApp';

export const getIcon = text => {
  switch (text?.toUpperCase()) {
    case 'ADICIONAR':
      return <PlusOutlined data-testid="adicionar Icon" aria-label="Botão de adicionar" />;
    case 'DELETAR':
      return <DeleteOutlined data-testid="deletar Icon" aria-label="Botão de deletar" />;
    case 'CANCELAR':
      return <CloseOutlined data-testid="cancelar Icon" aria-label="Botão de cancelar" />;
    case 'PESQUISAR':
      return <SearchOutlined data-testid="pesquisar Icon" aria-label="Botão de pesquisar" />;
    case 'EDITAR':
      return <EditOutlined data-testid="editar Icon" aria-label="Botão de editar" />;
    case 'FILTRAR':
      return <BarsOutlined data-testid="filtrar Icon" aria-label="Botão de filtrar" />;
    case 'SALVAR':
      return <SaveOutlined data-testid="salvar Icon" aria-label="Botão de salvar" />;
    case 'VOLTAR':
      return <ArrowLeftOutlined data-testid="voltar Icon" aria-label="Botão de voltar" />;
    case 'IMPRIMIR':
      return <PrinterOutlined data-testid="imprimir Icon" aria-label="Botão de imprimir" />;
    case 'BAIXAR':
      return <DownloadOutlined data-testid="baixar Icon" aria-label="Botão de baixar" />;
    case 'EXPORTAR GRÁFICO':
      return <DownloadOutlined data-testid="baixar Icon" aria-label="Botão de baixar" />;
    case 'EXPORTAR RELATÓRIO':
      return <DownloadOutlined data-testid="baixar Icon" aria-label="Botão de baixar" />;
    case 'LIMPAR FILTRO':
      return <ClearOutlined data-testid="Limpar Icon" aria-label="Botão de limpar" />;
    default:
      return null;
  }
};

export const validarImagem = file => {
  if (!file) {
    return { isError: true, mensagem: MSG_NENHUM_ARQUIVO_ENCONTRADO };
  }
  if (file.size > 10000000) {
    /* 2MB = 2.097.152 Bytes */
    /* 10 MB = 10000000 Bytes */
    return { isError: true, mensagem: MSG_TAMANHO_ARQUIVO_NAO_SUPORTADO };
  }
  if (!file.type.match(/pdf/)) {
    return { isError: true, mensagem: MSG_FORMATO_NAO_PERMITIDO_PDF };
  }
  return { isError: false, mensagem: '' };
};

export const checkUploadImagem = (e, funcUpload) => {
  const arq = e.target.files[0];
  const retorno = validarImagem(arq);
  if (retorno.isError) {
    fetchNotificationApp(retorno.mensagem, '', ALERTA.ERRO);
  } else {
    funcUpload(arq);
  }
  e.target.value = '';
  return retorno;
};

export const getStyleDisabled = disabled => {
  return disabled ? { color: '#c5c5c5', backgroundColor: '#787171', border: 'none' } : {};
};
